module.exports = __webpack_public_path__ + "img/img22.7d12a77a.svg";